(() => {
  const button = document.querySelector('[data-back-to-top]');
  if (!button) return;

  const revealAt = 2000;
  let ticking = false;

  const updateVisibility = () => {
    const isVisible = window.scrollY >= revealAt;
    button.classList.toggle('is-visible', isVisible);
    button.setAttribute('aria-hidden', String(!isVisible));
    ticking = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateVisibility);
    },
    { passive: true }
  );

  button.addEventListener('click', () => {
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    window.scrollTo({ top: 0, behavior });
  });

  updateVisibility();
})();
